import React from 'react';
import { Divider, Modal } from 'veloe-ds';

import './modais.scss';

import { getData, modalTarifas as modalTarifasData } from '../../api/dataAPI';

export const acessarMinhaConta = () => {
  window.location.href = 'https://minha.veloe.com.br/conta/login';
};

export const modalCadastroExistente = (
  open,
  onClose,
  typeModalDadosExistentes,
  message,
) => {
  const modalData = getData(typeModalDadosExistentes);
  return (
    <Modal
      {...{
        onClose: onClose,
        onOpen: () => {},
        open: open,
        hideButton: true,
        btnLabel: '',
        btnLabelColor: 'primary',
        type: 'scrollable',
        btnCloseColor: 'secondary',
        textVeloeBtn: modalData?.btnAcessarConta,
        textCloseBtn: modalData?.btnCancelar,
        onBg: 'light',
        size: 'medium',
        onClick: acessarMinhaConta,
        id: modalData?.id,
        header: modalData?.titulo,
      }}
    >
      <div className="containerTextos">
        <div className="containerTituloEtexto">
          <span className="subtituloDestaque">{message}</span>
        </div>
      </div>
    </Modal>
  );
};

export const modalInformativo = (open, onClose, titulo, texto) => {
  return (
    <Modal
      {...{
        hideButton: true,
        btnLabel: '',
        onClose: onClose,
        onOpen: () => {},
        open: open,
        btnLabelColor: 'primary',
        type: 'scrollable',
        btnCloseColor: 'secondary',
        onBg: 'light',
        size: 'lg',
        id: 'modal-informativo',
        header: titulo,
      }}
    >
      <div className="containerTextos">
        <div className="containerTituloEtexto">
          <span className="subtituloDestaque">{texto}</span>
        </div>
      </div>
    </Modal>
  );
};

export const modalAguarde = (open, onClose) => {
  const modalData = getData('modalAguarde');
  return (
    <div className="modal-informativo">
      <Modal
        {...{
          hideButton: true,
          btnLabel: '',
          onClose: onClose,
          onOpen: () => {},
          open: open,
          btnLabelColor: 'primary',
          type: 'scrollable',
          btnCloseColor: 'secondary',
          onBg: 'light',
          size: 'sm',
          id: 'modal-informativo',
          header: null,
        }}
      >
        <div className="containerTextos">
          <div className="containerTituloEtexto">
            <span className="tituloHeaderModal loading">
              {modalData.titulo}
            </span>
            <span className="subtituloDestaque">{modalData.texto}</span>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export const modalFinalizandoPagamento = (open, onClose) => {
  const modalData = getData('modalFinalizandoPagamento');
  return (
    <div className="modal-informativo">
      <Modal
        {...{
          hideButton: true,
          btnLabel: '',
          onClose: onClose,
          onOpen: () => {},
          open: open,
          btnLabelColor: 'primary',
          type: 'scrollable',
          btnCloseColor: 'secondary',
          onBg: 'light',
          size: 'sm',
          id: 'modal-informativo',
          header: null,
        }}
      >
        <div className="containerTextos">
          <div className="containerTituloEtexto">
            <span className="tituloHeaderModal loading">
              {modalData.titulo}
            </span>
            <span className="subtituloDestaque">{modalData.texto}</span>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export const modalNaoAprovado = (open, onClose) => {
  const modalData = getData('modalNaoAprovado');
  return (
    <Modal
      {...{
        hideButton: true,
        btnLabel: '',
        onClose: onClose,
        onOpen: () => {},
        open: open,
        btnLabelColor: 'primary',
        type: 'scrollable',
        btnCloseColor: 'secondary',
        onBg: 'light',
        size: 'sm',
        id: 'modal-informativo',
        header: null,
      }}
    >
      <div className="containerTextos">
        <div className="containerTituloEtexto">
          <span className="subtituloDestaque">{modalData.texto1}</span>
          <span className="subtituloDestaque">{modalData.texto2}</span>
        </div>
      </div>
    </Modal>
  );
};

export const modalProduto = (modalType) => {
  const modalData = getData(modalType);
  return (
    <Modal
      {...{
        link: true,
        onClose: () => {},
        onOpen: () => {},
        onBg: 'light',
        scroll: 'paper',
        btnCloseColor: 'secondary',
        btnLabel: 'Mais Detalhes',
        btnLabelColor: 'primary',
      }}
    >
      <div className="containerModalProdutos">
        <img
          className="imgPrincipalModalProdutos"
          src={require(`../../assets/modal/produtos/${modalData.imgPrincipal}`)}
          alt={modalData.titulo}
        />

        <span className="tituloModalProdutos">{modalData.titulo}</span>
        <img
          className="imgTituloModalProdutos"
          src={require(`../../assets/modal/produtos/${modalData.imgTituloPrincipal}`)}
          alt={modalData.titulo}
        />

        <div className="containerImgVeiculosModalProdutos">
          {modalData.imgVeiculos.map((imgVeiculos) => {
            return (
              <img
                key={imgVeiculos}
                className="imgVeiculosModalProdutos"
                src={require(`../../assets/modal/produtos/${imgVeiculos.img}`)}
                alt={modalData.titulo}
              />
            );
          })}
        </div>

        <span className="textoModalProdutos">{modalData.textoPrincipal}</span>

        {modalData.cards.map((card) => {
          return (
            <React.Fragment key={card.id}>
              {card.tipo === 'direita' ? (
                <div className="containerCardModalProdutosD">
                  <div className="containerTextosCardModalProdutos">
                    <span className="tituloCardModalProdutos">
                      {card.titulo}
                    </span>
                    <span className="textoCardModalProdutos">{card.texto}</span>
                    <span className="subTextoCardModalProdutos">
                      {card.subTitulo}
                    </span>
                  </div>
                  <img
                    className="imgCardModalProdutos"
                    src={require(`../../assets/modal/produtos/${card.img}`)}
                    alt={card.titulo}
                  />
                </div>
              ) : card.tipo === 'esquerda' ? (
                <div className="containerCardModalProdutosE">
                  <img
                    className="imgCardModalProdutos"
                    src={require(`../../assets/modal/produtos/${card.img}`)}
                    alt={card.titulo}
                  />
                  <div className="containerTextosCardModalProdutos">
                    <span className="tituloCardModalProdutos">
                      {card.titulo}
                    </span>
                    <span className="textoCardModalProdutos">{card.texto}</span>
                    <span className="subTextoCardModalProdutos">
                      {card.subTitulo}
                    </span>
                  </div>
                </div>
              ) : (
                <div className="containerCardModalProdutosC">
                  <div className="containerCardModalProdutosC2">
                    <span className="tituloCardModalProdutosC">
                      {card.titulo}
                    </span>
                    {card.tipoCentro.map((texts) => {
                      return (
                        <React.Fragment key={texts.id}>
                          <div className="containerTextoModalProdutosC">
                            <img
                              className="imgCheckCardModalProdutosC"
                              src={require('../../assets/modal/produtos/checkTexto.png')}
                              alt={card.titulo}
                            />
                            <span className="textoCardModalProdutosC">
                              {texts.texto}
                            </span>
                          </div>
                        </React.Fragment>
                      );
                    })}
                  </div>
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div>
    </Modal>
  );
};

export const modalPagamento = (modalType, haveDebit) => {
  const modalData = getData(modalType);
  return (
    <Modal
      {...{
        link: true,
        onClose: () => {},
        onOpen: () => {},
        onBg: 'light',
        scroll: 'body',
        btnCloseColor: 'secondary',
        btnLabel: 'Mais Detalhes',
        btnLabelColor: 'primary',
        maxWidth: 'sm',
        fullWidth: false,
        header: modalData.titulo,
      }}
    >
      <div>
        {modalData.cards.map((card) => {
          return (
            <React.Fragment key={card.id}>
              <div className="containerCardTextoModalTipoPagamento">
                <img
                  className="imgCardTipoPagamento"
                  src={require(`../../assets/modal/formaDePagamento/${card.icone}`)}
                  alt=""
                />
                {modalData.titulo === 'Como funciona a recarga automática'
                  ? card.texto
                  : ''}
                {haveDebit ? card.debitText : card.texto}
              </div>
            </React.Fragment>
          );
        })}
      </div>
    </Modal>
  );
};

export const modalTarifas = (bonificacao, valor) => {
  const modalData = modalTarifasData(bonificacao, valor);
  return (
    <Modal
      {...{
        link: true,
        onClose: () => {},
        onOpen: () => {},
        btnLabel: 'Saiba sobre as tarifas',
        btnLabelColor: 'primary',
        type: 'scrollable',
        btnCloseColor: 'secondary',
        header: 'Tarifas',
        onBg: 'light',
        size: 'sm',
        id: 'modal-tarifas',
      }}
    >
      <div>
        <div className="containerTextos">
          <div className="containerTituloEtexto">
            <span className="subtituloDestaque">Mensalidades</span>
            <span className="textoPequeno">{modalData.inicioPagto}</span>
          </div>

          <span className="lblResposta">{modalData.aPartir}</span>
        </div>
        <Divider type="full" onBg="light" />

        <div className="containerTextos">
          <div className="containerTituloEtexto">
            <span className="subtituloDestaque">Demais detalhes</span>
            <span className="lblTextoGrande"> Tarifa de adesão </span>
          </div>
          <span className="lblResposta">{modalData.tarifaAdesao}</span>
        </div>
        <Divider type="full" onBg="light" />
        <div className="containerTextos">
          <div className="containerTituloEtexto">
            <span className="lblTextoGrande">Tarifa de entrega </span>
          </div>
          <span className="lblResposta">{modalData.tarifaEntrega}</span>
        </div>
        <Divider type="full" onBg="light" />
        <div className="containerTextos">
          <div className="containerTituloEtexto">
            <span className="lblTextoGrande"> Inativação</span>
            <span className="textoPequeno">
              Valor mensal por adesivo não ativado após 30 dias do recebimento
            </span>
          </div>
          <span className="lblResposta">{modalData.inativacao}</span>
        </div>
        <Divider type="full" onBg="light" />
        <div className="containerTextos">
          <div className="containerTituloEtexto">
            <span className="lblTextoGrande">Extrato impresso</span>
            <span className="textoPequeno">
              Valor único cobrado por extrato em papel quando solicitado pelo
              cliente.
            </span>
          </div>
          <span className="lblResposta">{modalData.extrato}</span>
        </div>
        <Divider type="full" onBg="light" />
        <div className="containerTextos">
          <div className="containerTituloEtexto">
            <span className="lblTextoGrande"> Substituição do adesivo </span>
          </div>
          <span className="lblResposta">{modalData.substituicao}</span>
        </div>
        <Divider type="full" onBg="light" />
        <div className="containerTextos">
          <div className="containerTituloEtexto">
            <span className="lblTextoGrande"> Serviço adicional </span>
          </div>
          <span className="lblResposta"> {modalData.adicional} </span>
        </div>
        <Divider type="full" onBg="light" />
        <div className="containerTextos">
          <div className="containerTituloEtexto">
            <span className="lblTextoGrande">Devolução de saldo </span>
            <span className="textoPequeno">
              Valor único cobrado quando o cliente encerrar a conta e solicitar
              a devolução de saldo, ou solicitar a devolução de saldo.
            </span>
          </div>
          <span className="lblResposta">{modalData.devolucaoSaldo}</span>
        </div>
        <Divider type="full" onBg="light" />
        <span className="lblTextosParteInferior">
          <strong> *Sujeito a escolha de modalidade</strong>
        </span>
        <br />
        <span className="lblTextosParteInferior">
          <strong>Recarga automática: </strong>Uma recarga será feita no seu
          cartão de crédito sempre que o saldo estiver acabando.
        </span>
        <br />
        <span className="lblTextosParteInferior">
          <strong>Recarga mínima: </strong> {modalData.recargaMinima}
        </span>
        <br />
        <span className="lblTextosParteInferior">
          <strong>Pós-pago:</strong> Pague sua fatura mensal após o uso com
          débito.
        </span>
      </div>
    </Modal>
  );
};

export const modalPlanoSemMensalidade = (resumoPedido = false) => {
  return (
    <Modal
      {...{
        link: true,
        onClose: () => {},
        onOpen: () => {},
        btnLabel: resumoPedido
          ? 'Saiba sobre as tarifas'
          : 'Conheça as taxas de recargas.',
        btnLabelColor: 'primary',
        type: 'scrollable',
        btnCloseColor: 'secondary',
        header: 'Tarifas de recarga',
        onBg: 'light',
        size: 'sm',
        id: 'modal-tarifas',
      }}
    >
      <div>
        <div className="containerTextos">
          <span className="tituloModalProdutoManual">Valor</span>
          <span className="tituloModalProdutoManual">Taxa</span>
          <span className="tituloModalProdutoManual">% propocional</span>
        </div>
        <Divider type="full" onBg="light" />

        <div className="containerTextos">
          <span className="textoModalProdutoManual">R$ 50,00</span>
          <span className="textoModalProdutoManual">R$ 9,90</span>
          <span className="textoModalProdutoManual">20%</span>
        </div>
        <Divider type="full" onBg="light" />

        <div className="containerTextos">
          <span className="textoModalProdutoManual">R$ 75,00</span>
          <span className="textoModalProdutoManual">R$ 12,90</span>
          <span className="textoModalProdutoManual">17%</span>
        </div>
        <Divider type="full" onBg="light" />

        <div className="containerTextos">
          <span className="textoModalProdutoManual">R$ 100,00</span>
          <span className="textoModalProdutoManual">R$ 15,90</span>
          <span className="textoModalProdutoManual">16%</span>
        </div>
        <Divider type="full" onBg="light" />

        <div className="containerTextos">
          <span className="textoModalProdutoManual">R$ 150,00</span>
          <span className="textoModalProdutoManual">R$ 21,90</span>
          <span className="textoModalProdutoManual">15%</span>
        </div>
        <Divider type="full" onBg="light" />

        <div className="containerTextos">
          <span className="textoModalProdutoManual">R$ 200,00</span>
          <span className="textoModalProdutoManual">R$ 30,90</span>
          <span className="textoModalProdutoManual">15%</span>
        </div>
        <Divider type="full" onBg="light" />

        <div className="containerTextos">
          <span className="textoModalProdutoManual">R$ 250,00</span>
          <span className="textoModalProdutoManual">R$ 32,90</span>
          <span className="textoModalProdutoManual">13%</span>
        </div>
        <Divider type="full" onBg="light" />

        <div className="containerTextos">
          <span className="textoModalProdutoManual">R$ 350,00</span>
          <span className="textoModalProdutoManual">R$ 34,90</span>
          <span className="textoModalProdutoManual">10%</span>
        </div>
        <Divider type="full" onBg="light" />

        <div className="containerTextos">
          <span className="textoModalProdutoManual">R$ 500,00</span>
          <span className="textoModalProdutoManual">R$ 44,90</span>
          <span className="textoModalProdutoManual">9%</span>
        </div>
      </div>
    </Modal>
  );
};
